import { Tabs } from '@shopify/polaris';
import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const tabs = [
    { id: 'orders', content: 'Orders', path: '/integrations/atd/orders' },
    { id: 'preview', content: 'Preview order', path: '/integrations/atd/preview' },
];

const AtdTabs = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const selected = useMemo(() => {
        const index = tabs.findIndex(tab => location.pathname.startsWith(tab.path));
        return index >= 0 ? index : 0;
    }, [location.pathname]);

    const handleSelect = useCallback((index: number) => {
        navigate(tabs[index].path);
    }, [navigate]);

    return (
        <Tabs
            tabs={tabs.map(tab => ({ id: tab.id, content: tab.content }))}
            selected={selected}
            onSelect={handleSelect}
        />
    );
};

export default AtdTabs;
